import { Filter } from '@fabric-ui/components';

export enum MatchType {
  ALL = 'ALL',
  ANY = 'ANY',
}

export type IncidentRuleFieldGrouping = {
  fields: string[];
  matchType: MatchType;
};

export type IncidentRuleGrouping = {
  fieldGrouping: IncidentRuleFieldGrouping;
};

export type TimeFrame = {
  hoursBefore: number;
};

export type RuleMetadata = {
  fromAgent: {
    createForEach?: boolean;
    matchType?: boolean;
    grouping?: boolean;
    timeFrame?: boolean;
  };
};

export type Rule = {
  id?: string;
  name: string;
  grouping?: IncidentRuleGrouping;
  condition?: Filter;
  entityTitleFormat?: string;
  timeFrame?: TimeFrame;
  createForEach?: boolean;
};

export type RuleWithMetadata = Rule & {
  _metadata?: RuleMetadata;
};

export type VersionMetadata = {
  innerId: string;
  versionDate: string;
};

export type IncidentRuleSet = {
  name: string;
  isActive: boolean;
  projectionName: string;
  description: string;
  hidden?: boolean;
  rules: Rule[];
  id: string;
  updatedAt?: string;
  updatedByUserId?: string;
  versionMetadata?: VersionMetadata;
};

export type IncidentRuleSetWithMetadata = Omit<IncidentRuleSet, 'rules'> & {
  rules: RuleWithMetadata[];
};

export type IncidentRuleErrors = { [K in keyof Rule]?: string };
export type IncidentRulesErrors = {
  createRule: IncidentRuleErrors;
  attachRule: IncidentRuleErrors;
};
export type IncidentRuleSetErrors = { [K in keyof Omit<IncidentRuleSet, 'rules'>]?: string } & IncidentRulesErrors;

export const dto: IncidentRuleSet = {
  id: '1dfsdg',
  name: 'Test Rule Set',
  isActive: true,
  projectionName: 'incidents',
  description: 'description',
  rules: [
    {
      name: 'Create Incident',
      grouping: {
        fieldGrouping: {
          fields: ['asset.tags'],
          matchType: MatchType.ALL,
        },
      },
      entityTitleFormat: ' risk by {{asset.base_image}}',
      createForEach: false,
      condition: {
        and: {
          operands: [
            {
              expression: {
                fieldName: 'asset.first_seen',
                dateCondition: {
                  between: {
                    values: [new Date('2025-05-11T13:22:59.205Z'), new Date('2025-05-11T13:22:59.205Z')],
                  },
                },
              },
            },
          ],
        },
      },
      timeFrame: {
        hoursBefore: 12,
      },
    },
    {
      name: 'Attach to Incident',
      grouping: {
        fieldGrouping: {
          fields: ['finding._key'],
          matchType: MatchType.ALL,
        },
      },
      condition: {
        and: {
          operands: [
            {
              expression: {
                fieldName: 'asset.type',
                stringCondition: {
                  contains: 'MAC',
                },
              },
            },
          ],
        },
      },
      timeFrame: {
        hoursBefore: 12,
      },
    },
  ],
};

export const DEFAULT_ATTACK_PATH_RULE = 'Attack Path Default Rule Set';
